export default [
    {
        label: '姓名',
        name: "FNAME",
        type: "input",
        disabled:false,
        rules: [{
            required: true,
            message:'请输入姓名'
           
        }],//字母数字，长度不能超过8位
        placeholder:'请输入姓名',
    },
    {
      label: '性别',
      name: "FSEX",
      type: "radio",
      options: [
          // {
          //     value: '0',
          //     label: '男',
          // },
          // {
          //     value: '1',
          //     label: '女',
          // },
      ],
      rules: [{required: true, message: '请选择性别'}],
    },
    {
      label: '籍贯',
      name: "FNATIVEPLACE",
      type: "input",
      rules: [{
          required: true,
          message:'请输入籍贯'
         
      }],
      placeholder:'请输入籍贯',
    },
    {
      label: '出生年月',
      name: "FBIRTHDATE",
      type: "dayPicker",
      disabledType:'2',
      rules: [{
        required: true,
        validator:(rule, value,callback)=>{
            if (value === '' || value == undefined ) {
                callback('请选择出生年月');
            } else{
                callback();
            }
        },
      }],
    },
    {
      label: '身份证号',
      name: "FIDCARDNO",
      type: "input",
      rules: [{
          required: true,
          validator:(rule, value,callback)=>{
            let reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (value === '' || value == undefined ) {
              callback('请输入有效的身份证号' );
            }else if (!reg.test(value)) {
              callback('请输入有效的身份证号' );
            }else{
              callback();
            }
          },
          message:'请输入身份证号'
         
      }],
      placeholder:'请输入身份证号',
    },
  
    // {
    //     label: '籍贯',
    //     name: "FNATIVEPLACE",
    //     type: "cascader",
    //     options: [
    //         {
    //           value: 'zhejiang',
    //           label: 'Zhejiang',
    //           children: [
    //             {
    //               value: 'hangzhou',
    //               label: 'Hangzhou',
    //               children: [
    //                 {
    //                   value: 'xihu',
    //                   label: 'West Lake',
    //                 },
    //               ],
    //             },
    //           ],
    //         },
    //         {
    //           value: 'jiangsu',
    //           label: 'Jiangsu',
    //           children: [
    //             {
    //               value: 'nanjing',
    //               label: 'Nanjing',
    //               children: [
    //                 {
    //                   value: 'zhonghuamen',
    //                   label: 'Zhong Hua Men',
    //                 },
    //               ],
    //             },
    //           ],
    //         },
    //     ],
    //     rules: [{required: true, message: '请选择籍贯'}],
    //     placeholder:'请选择籍贯'
    // },
    {
      label: '政治面貌',
      name: "FPOLITICALFACE",
      type: "select",
      showSearch:true,
      options: [],
      // field:{ label: 'siteName', value: 'siteLsh', options: 'options' },
      rules: [{required: true, message: '请选择政治面貌'}],
    },
    {
      label: '最高学历',
      name: "FHIGHESTDEGREE",
      type: "select",
      showSearch:true,
      options: [
        { label:'小学',value:'0',},
        { label:'初中',value:'1',},
        { label:'高中',value:'2',},
        { label:'大专',value:'3',},
        { label:'本科',value:'4',},
        { label:'研究生',value:'5',},
      ],
      // field:{ label: 'siteName', value: 'siteLsh', options: 'options' },
      rules: [{required: true, message: '请选择学历'}],
    },
    {
      label: '学位',
      name: "FDEGREE",
      type: "input",
      rules: [{
          required: true,
          message:'请输入学业'
      }],
      placeholder:'请输入学业',
    },
    {
      label: '毕业院校',
      name: "FUNIVERSITY",
      type: "input",
      rules: [{
          required: true,
          message:'请输入毕业院校'
      }],
      placeholder:'请输入毕业院校',
    },
    {
      label: '毕业专业',
      name: "FMAJOR",
      type: "input",
      disabled:false,
      rules: [{
          required: true,
          message:'请输入毕业专业'
         
      }],
      placeholder:'请输入毕业专业',
    },
    {
      label: '毕业时间',
      name: "F_KDY_BYSJ",
      type: "dayPicker",
      disabledType:'1',
      rules: [{
        required: true,
        validator:(rule, value,callback)=>{
            if (value === '' || value == undefined ) {
                callback('请选择毕业时间');
            } else{
                callback();
            }
        },
      }],
    },
    {
      label: '是否应届',
      name: "isFresh",
      type: "radioisFresh",
      options: [
          {
              value: '1',
              label: '应届',
          },
          {
              value: '2',
              label: '非应届',
          },
      ],
      rules: [{required: true, message: '请选择是否为应届'}],
    },
    {
      label: '参加工作时间',
      name: "F_KDY_CJGZSJ",
      type: "dayPicker",
      disabledType:'1',
      rules: [{
        required: true,
        validator:(rule, value,callback)=>{
            if (value === '' || value == undefined ) {
                callback('请选择参加工作时间');
            } else{
                callback();
            }
        },
      }],
    },
    {
      label: '现工作单位',
      name: "F_KDY_XGZDW",
      type: "input",
      rules: [{
          required: true,
          message:'请输入现工作单位'
      }],
      placeholder:'请输入现工作单位',
    },
    {
      label: '是否有（护士/医师）执业资格',
      name: "FRTCERTIFICATE",
      labelcol:true,
      type: "radio",
      options: [
        // {
        //   value: '0',
        //   label: '有',
        // },
        // {
        //     value: '1',
        //     label: '无',
        // },
      ],
      rules: [{required: true, message: '是否有（护士/医师）执业资格'}],
    },
    {
      label: '职业资格（职称）',
      name: "FEMPTITLEID",
      type: "input",
      rules: [{
          required: true,
          message:'请输入职业资格（职称）'
      }],
      placeholder:'请输入职业资格（职称）',
    },
    {
      label: '有何特长/获得奖证情况',
      name: "F_KDY_TC",
      type: "textarea",
    },
    {
      label: '外语语种及等级',
      name: "F_KDY_WY",
      type: "textarea",
    },
    {
      label: '联系电话',
      name: "FPHONENUM",
      type: "input",
      rules: [{
          required: true,
          validator:(rule, value,callback)=>{
            var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (value === '' || value == undefined ) {
              callback('请输入联系电话' );
            }else if (!reg.test(value)) {
              callback('联系电话格式错误' );
            }else{
                callback();
            }
          },
      }],
      placeholder:'请输入联系电话',
    },
    {
      label: '电子邮箱',
      name: "FEMAIL",
      type: "input",
      rules: [{
          required: true,
          validator:(rule, value,callback)=>{
            var reg =/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (value === '' || value == undefined ) {
              callback('请输入电子邮箱' );
            }else if (!reg.test(value)) {
              callback('电子邮箱格式错误' );
            }else{
                callback();
            }
          },
      }],
      placeholder:'请输入电子邮箱',
    },
    {
      label: '联系地址',
      name: "FLIVEADDRESS",
      type: "input",
      rules: [{
          required: true,
          message:'请输入联系地址'
      }],
      placeholder:'请输入联系地址',
    },
    {
      // label: '简历（从高中填起，学习及工作情况）',
      label: '学习情况（从高中填起）',
      name: "RESUME",
      type: "addObject",
      addType:
        [
          {
            label:'时间',
            key:'F_KDY_SJ',
          },
          {
            // label:'毕业院校及专业/工作单位及职务',
            label:'毕业院校及专业',
            key:'F_KDY_BYYX',
          }
      ],
      rules: [{
          required: true,
          message:'请输入简历'
      }],
    },
    {
      label: '工作情况',
      name: "RESUME_WORK",
      type: "addObject",
      addType:
        [
          {
            label:'时间',
            key:'F_KDY_SJ',
          },
          {
            label:'工作单位及职务',
            key:'F_KDY_BYYX',
          }
      ],
      rules: [{
          required: false,
          message:'请输入工作情况'
      }],
    },
    {
      label: '家庭主要成员',
      name: "FAMILY",
      type: "addObject",
      addType:
        [
          {
            label:'姓名',
            key:'FFAMILYNAME',
          },
          {
            label:'关系',
            key:'FFAMILYRELATION',
          },
          {
            label:'所在单位',
            key:'FFAMILYWORKUNIT',
          },
          {
            label:'职务',
            key:'FFAMILYPOST',
          }
      ],
      rules: [{
          required: true,
      }],
      placeholder:'请输入家庭成员信息集合',
    },
    {
      name:"remarks"
    }
]
